import { createAction } from '@reduxjs/toolkit';
import { ShowNftsMetadataReq } from 'types/requests';
import actionTypes from './actionTypes';

export const showNftsMetadata = createAction<ShowNftsMetadataReq>(
  actionTypes.SHOW_NFT_METADATA,
);
